import {
  CertificateCardCME,
  CertificateCardCPE,
  DemoDegreeIntroductionImg,
  IntroductionBannerCME,
  IntroductionBannerCPE,
} from '@/constant/imgImport';
import {
  EDegreeSubTabSectionKey,
  EDegreeTabSectionKey,
  TDegreeSubTabSection,
  TEnterpriseProfileDegreeTabSection,
} from '@/interfaces/enterprise-profile/degree_tab.interface';
import { CourseCertificateEnum } from '@/interfaces/training.interface';

export const hashDegreeSectionName = {
  [EDegreeTabSectionKey.Introduction]: 'Giới thiệu',
  [EDegreeTabSectionKey.TrainingCertification]: 'Chứng chỉ đào tạo',
  [EDegreeTabSectionKey.FrequentlyAsks]: 'Câu hỏi thường gặp',
};

export const defaultDegreeSection: TEnterpriseProfileDegreeTabSection = [
  {
    sectionName: hashDegreeSectionName[EDegreeTabSectionKey.Introduction],
    sectionKey: EDegreeTabSectionKey.Introduction,
    elements: {
      image: DemoDegreeIntroductionImg,
    },
    isActive: true,
  },
  {
    sectionName:
      hashDegreeSectionName[EDegreeTabSectionKey.TrainingCertification],
    sectionKey: EDegreeTabSectionKey.TrainingCertification,
    elements: {
      [CourseCertificateEnum.CME]: {
        image: CertificateCardCME,
        isActive: true,
        subTab: [
          {
            sectionKey: EDegreeSubTabSectionKey.Introduction,
            elements: {
              image: IntroductionBannerCME,
            },
            isActive: true,
          },
          {
            sectionKey: EDegreeSubTabSectionKey.Courses,
            isActive: true,
          },
        ],
      },
      [CourseCertificateEnum.CPE]: {
        image: CertificateCardCPE,
        isActive: true,
        subTab: [
          {
            sectionKey: EDegreeSubTabSectionKey.Introduction,
            elements: {
              image: IntroductionBannerCPE,
            },
            isActive: true,
          },
          {
            sectionKey: EDegreeSubTabSectionKey.Courses,
            isActive: true,
          },
        ],
      },
    },
    isActive: true,
  },
  {
    sectionName: hashDegreeSectionName[EDegreeTabSectionKey.FrequentlyAsks],
    sectionKey: EDegreeTabSectionKey.FrequentlyAsks,
    isActive: true,
    elements: {
      questions: [
        {
          question: 'Đăng ký chứng chỉ như thế nào?',
          answer: 'Đăng ký chứng chỉ như thế nào?',
        },
        {
          question: 'Phí đăng ký là bao nhiêu ?',
          answer:
            'If someone has uploaded their contacts and it includes your mobile phone number or email address, you may show up as If someone has uploaded their contacts and it includes your mobile phone number or email address, you may show up your mobile phone num',
        },
        {
          question: 'Thời gian đào tạo chứng chỉ là bao lâu ?',
          answer: 'Thời gian đào tạo chứng chỉ là bao lâu ?',
        },
        {
          question: 'Cơ hội việc làm sau khi ra trường ?',
          answer: 'Cơ hội việc làm sau khi ra trường ?',
        },
      ],
    },
  },
];

export const defaultDegreeSubTab: TDegreeSubTabSection[] = [
  {
    sectionKey: EDegreeSubTabSectionKey.Introduction,
    elements: {
      image: '',
    },
    isActive: true,
  },
  {
    sectionKey: EDegreeSubTabSectionKey.Courses,
    isActive: true,
  },
];
